import { mapDTO } from '@twistezo/ts-dto-mapper'
import { isEmpty } from 'lodash'

import { Schema } from '../../../schema'
import { Variables } from './types'

type From = Schema
type To = Pick<Variables, 'bannerTemplateId'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schema: From): To => {
    const { bannerTemplateId } = schema

    return {
      bannerTemplateId: isEmpty(bannerTemplateId) ? null : Number(bannerTemplateId),
    }
  })
